<template>
    <div class="carousel" ref="carousel">
        <!-- <swiper :options="swiperOption">
            <swiper-slide class="swiper-slide" v-for="(item,index) in 5" :key="index">
                <a href="javascript:;"
                   target="_blank">
                    <img src="../../assets/images/s_banner_2.jpg" alt=""/>
                    <span class="title">{{item.title}}</span>
                </a>
            </swiper-slide>
            <div class="swiper-pagination"  slot="pagination"></div>
        </swiper> -->
        <img src="../../assets/images/s_banner_2.jpg" alt=""/>   
    </div>
</template>

<script>

export default{
    name: 'Carousel',
    props:{

    },
    data(){
        return{
            swiperOption:{
                //显示分页
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                loop: true
            },
            imgList: []   
        }
    }
}
</script>

<style lang="less" scoped>
    .carousel{
        img{
            width: 100%;
        }
    }           
</style>   